export default __webpack_public_path__ + "static/media/nextArrow.8387fa0a.webp";